import "./styles/Story.css";

const Story = () => {
  return (
    <div className="story">
      <h3>品牌故事</h3>
      <h2>核心理念核心理念</h2>
      <p>
        成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是然，也許是大環境改變，成立於1972年的克雷斯補習班，經營規模盛極一時。或許是企業週期使然，也許是大環境改變。
      </p>
      <img src="/Assets/about/story.png" alt="" />
    </div>
  );
};

export default Story;
